import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { fetchSettings } from "../hooks/useSettings";

interface FooterProps {
  isDarkMode: boolean; // Add prop
}

const Footer: React.FC<FooterProps> = ({ isDarkMode }) => {
  const navigate = useNavigate();
  const [logoSettings, setLogoSettings] = useState<{ light?: string; dark?: string }>({});

  useEffect(() => {
    fetchSettings().then((data) => {
      setLogoSettings({
        light: data.site_footer_logo_light,
        dark: data.site_footer_logo_dark,
      });
    });
  }, []);

  return (
    <footer className="w-full max-w-[1120px] mx-auto px-4 mt-auto border-t border-border-subtle dark:border-white/10 pt-12 pb-8">
      <div className="bg-surface dark:bg-surface-dark border border-border-subtle dark:border-white/10 rounded-2xl p-8 md:p-12 mb-12 flex flex-col md:flex-row items-center justify-between gap-8 shadow-sm">
        <div className="max-w-md">
          <h2 className="font-tight text-2xl font-bold text-text-main dark:text-white mb-2">
            Ready to transform your business?
          </h2>
          <p className="text-text-sub dark:text-gray-400">
            Get a free consultation for your next big project.
          </p>
        </div>
        <div className="flex gap-4">
          <Link
            to="/contact"
            className="bg-primary hover:bg-red-600 text-white text-sm font-bold px-6 py-3 rounded-xl transition-all shadow-lg shadow-primary/20 block text-center"
          >
            Contact Sales
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-8 mb-12 items-start">
        <div className="col-span-2 md:col-span-1 flex flex-col justify-start">
          <div className="mb-4">
            <Link to="/" className="inline-block" aria-label="InnovaTech Home">
              <img
                src={
                  isDarkMode
                    ? (logoSettings.dark || "/logo/dark-footer.webp")
                    : (logoSettings.light || "/logo/light-footer.webp")
                }
                alt="InnovaTech Logo"
                width="150"
                height="44"
                className="h-10 w-auto object-contain object-left"
              />
            </Link>
          </div>
          <p className="text-xs text-text-sub dark:text-gray-500 leading-relaxed">
            Precision engineering for the digital age. <br />
            No.2 Salmaniyya Plaza, Opp, TCN,
            <br />
            Ibrahim Aliyu Bypass, Dutse, Jigawa State
            <br />© 2026 InnovaTech Inc.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-text-main dark:text-white text-sm mb-3">
            Services
          </h3>
          <ul className="space-y-2 text-xs text-text-sub dark:text-gray-400">
            <li>
              <Link
                to="/services"
                className="hover:text-primary transition-colors"
              >
                Web Development
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-primary transition-colors"
              >
                Mobile App Development
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-primary transition-colors"
              >
                Cloud &amp; Hosting
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-primary transition-colors"
              >
                Cybersecurity
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-primary transition-colors"
              >
                CCTV &amp; Surveillance
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="font-bold text-text-main dark:text-white text-sm mb-3">
            Company
          </h3>
          <ul className="space-y-2 text-xs text-text-sub dark:text-gray-400">
            <li>
              <Link
                to="/about"
                className="hover:text-primary transition-colors"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-primary transition-colors"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/courses"
                className="hover:text-primary transition-colors"
              >
                Academy
              </Link>
            </li>
            <li>
              <Link
                to="/programmes"
                className="hover:text-primary transition-colors"
              >
                Programmes
              </Link>
            </li>
            <li>
              <Link to="/team" className="hover:text-primary transition-colors">
                Team
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-primary transition-colors"
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex justify-center h-[150px] w-full rounded-lg overflow-hidden border border-border-subtle dark:border-white/10 relative">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d3907.0222953829384!2d9.3479818!3d11.6928323!3m2!1i1024!2i768!4f13.1!2m1!1sinnovatech!5e0!3m2!1sen!2sng!4v1766350541190!5m2!1sen!2sng"
          width="100%"
          height="100%"
          title="InnovaTech Head Office Location Map"
          style={{ border: 0, filter: "grayscale(100%) opacity(0.5)" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="hover:filter-none hover:opacity-100 transition-all duration-500"
        ></iframe>
      </div>
    </footer>
  );
};

export default Footer;
